export const SITE_KEY = "6Lf-JWgkAAAAAG64xXkjGuUf2Cnm1v0B7dYNnW5D";

export const GOOGLE_CLIENT_LOGIN = "420562049354-9f566jv2rulmkkc991f7jn2o7lmp80vn.apps.googleusercontent.com";

export const SITE_KEY_INVISIBLE = "6LfboY8oAAAAAL82-6KVnm3kaMosJFkMwwTZJIOm";
